import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

const Dashboard = Loadable(lazy(() => import('views/pages/dashboard')));
const KnowledgeWarehouse = Loadable(lazy(() => import('views/pages/knowledge-warehouse')));
const RegisterClientAdmin = Loadable(lazy(() => import('views/pages/register-client-admin')));
const CompanyRegistration = Loadable(lazy(() => import('views/pages/company-registration')));
const BotConfiguration = Loadable(lazy(() => import('views/pages/bot-configuration')));
const FAQ = Loadable(lazy(() => import('views/pages/cache-warehouse')));
const EndUsers = Loadable(lazy(() => import('views/pages/end-users')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        { path: '/dashboard', element: <Dashboard /> },
        { path: '/company-registration', element: <CompanyRegistration /> },
        { path: '/register-client-admin', element: <RegisterClientAdmin /> },
        { path: '/bot-configuration', element: <BotConfiguration /> },
        { path: '/knowledge-warehouse', element: <KnowledgeWarehouse /> },
        { path: '/faq', element: <FAQ /> },
        { path: '/end-users', element: <EndUsers /> }
    ]
};

export default MainRoutes;
